import {http} from '../utils'
// 查询
const searchAction = (params) => {
  const url = `/market/ai/task/member/page`
  return http.post(url, params)
}
// 获取status列表
const getStatus = (params) => {
  const url = `/market/ai/task/member/detail`
  return http.post(url, params)
}

export default {
  searchAction,
  getStatus,
}
